import "core-js/modules/es6.promise";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.weak-map";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.string.ends-with";
import "core-js/modules/es6.string.starts-with";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.array.find";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.object.entries";
import "core-js/modules/es6.object.assign";
export function applyPolyfills() {
  var promises = [];

  if (typeof window !== 'undefined') {
    var checkIfURLIsSupported = function checkIfURLIsSupported() {
      try {
        var u = new URL('b', 'http://a');
        u.pathname = 'c%20d';
        return u.href === 'http://a/c%20d' && u.searchParams;
      } catch (e) {
        return false;
      }
    };

    var win = window;

    if (!win.customElements || win.Element && (!win.Element.prototype.closest || !win.Element.prototype.matches || !win.Element.prototype.remove || !win.Element.prototype.getRootNode)) {
      promises.push(import(
      /* webpackChunkName: "polyfills-dom" */
      './dom.js'));
    }

    if ('function' !== typeof Object.assign || !Object.entries || !Array.prototype.find || !Array.prototype.includes || !String.prototype.startsWith || !String.prototype.endsWith || win.NodeList && !win.NodeList.prototype.forEach || !win.fetch || !checkIfURLIsSupported() || typeof WeakMap == 'undefined') {
      promises.push(import(
      /* webpackChunkName: "polyfills-core-js" */
      './core-js.js'));
    }
  }

  return Promise.all(promises);
}